export enum AndromedaPalettes {
	Basic = 'basic',
	Primary = 'primary',
	Accent = 'accent',
	Warn = 'warn',
	Disabled = 'disabled',
}
